class RecipesSlider {
  constructor(section) {
    this.section = section;
    this.slider = section.querySelector('[data-slider]');
    this.videos = section.querySelectorAll('[data-video]');
    this.playButtons = section.querySelectorAll('[data-play-button]');
    this.muteButtons = section.querySelectorAll('[data-mute-button]');

    if (this.slider) {
      this.initSlider();
      this.initVideoControls();
      this.initIntersectionObserver();
    }
  }

  initSlider() {
    this.swiperInstance = new Swiper(this.slider, {
      slidesPerView: 'auto',
      spaceBetween: 18,
      grabCursor: true,
      pagination: {
        el: '.section-recipes-slider__pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.section-recipes-slider__button-next',
        prevEl: '.section-recipes-slider__button-prev',
      },
      breakpoints: {
        320: {
          spaceBetween: 16,
        },
        990: {
          spaceBetween: 18,
        },
      },
      on: {
        slideChange: () => {
          this.pauseAllVideos();
        },
      },
    });
  }

  initVideoControls() {
    this.playButtons.forEach((button, index) => {
      const slide = button.closest('.swiper-slide');
      const video = slide.querySelector('[data-video]');

      if (video) {
        button.addEventListener('click', () => {
          this.togglePlay(video, button);
        });
      }
    });

    this.muteButtons.forEach((button, index) => {
      const slide = button.closest('.swiper-slide');
      const video = slide.querySelector('[data-video]');

      if (video) {
        button.addEventListener('click', () => {
          this.toggleMute(video, button);
        });
      }
    });
  }

  togglePlay(video, button) {
    const playIcon = button.querySelector('[data-play]');
    const pauseIcon = button.querySelector('[data-pause]');

    if (video.paused) {
      video.play();
      playIcon.style.display = 'none';
      pauseIcon.style.display = 'block';
      button.setAttribute('aria-label', 'Pause video');
    } else {
      video.pause();
      playIcon.style.display = 'block';
      pauseIcon.style.display = 'none';
      button.setAttribute('aria-label', 'Play video');
    }
  }

  toggleMute(video, button) {
    const mutedIcon = button.querySelector('[data-muted]');
    const unmutedIcon = button.querySelector('[data-unmuted]');

    if (video.muted) {
      video.muted = false;
      mutedIcon.style.display = 'none';
      unmutedIcon.style.display = 'block';
      button.setAttribute('aria-label', 'Mute video');
    } else {
      video.muted = true;
      mutedIcon.style.display = 'block';
      unmutedIcon.style.display = 'none';
      button.setAttribute('aria-label', 'Unmute video');
    }
  }

  pauseAllVideos() {
    this.videos.forEach((video) => {
      if (!video.paused) {
        video.pause();

        // Reset play button icon
        const slide = video.closest('.swiper-slide');
        const playButton = slide.querySelector('[data-play-button]');
        if (playButton) {
          const playIcon = playButton.querySelector('[data-play]');
          const pauseIcon = playButton.querySelector('[data-pause]');
          if (playIcon && pauseIcon) {
            playIcon.style.display = 'block';
            pauseIcon.style.display = 'none';
          }
          playButton.setAttribute('aria-label', 'Play video');
        }
      }
    });
  }

  initIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          this.pauseAllVideos();
        }
      });
    }, options);

    this.observer.observe(this.section);
  }

  destroy() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy();
    }
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRecipesSliders);
} else {
  initRecipesSliders();
}

function initRecipesSliders() {
  const sections = document.querySelectorAll('[data-section-type="w-recipes-slider"]');
  sections.forEach((section) => {
    new RecipesSlider(section);
  });
}

// Shopify Theme Editor support
if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="w-recipes-slider"]');
    if (section) {
      new RecipesSlider(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-section-type="w-recipes-slider"]');
    if (section && section.recipesSliderInstance) {
      section.recipesSliderInstance.destroy();
    }
  });
}

// Expose class globally for dynamic initialization
window.RecipesSlider = RecipesSlider;
